import { render, staticRenderFns } from "./CardOrganization.vue?vue&type=template&id=537458f4"
import script from "./CardOrganization.vue?vue&type=script&lang=js"
export * from "./CardOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports